import { getLabel } from "app/shared/constants/Literals";

export const PICKUP_TYPE_VALUES = {
  WALK_IN: 'WALK-IN',
  DRIVE_THRU: 'DRIVE-THRU',
  CURBSIDE: 'CURBSIDE',
} as const;

export type PickupType = typeof PICKUP_TYPE_VALUES[keyof typeof PICKUP_TYPE_VALUES];

interface PickupConfig {
  enabled: boolean;
  label: string;
  description?: string;
  apiValue?: string;
}

export const PICKUP_TYPES: Record<PickupType, PickupConfig> = {
  [PICKUP_TYPE_VALUES.WALK_IN]: {
    enabled: true,
    label: getLabel('PICKUP_INFO', 'walkIn'),
    description: getLabel('PICKUP_INFO', 'walkInDescription'),
    apiValue: 'walk_in',
  },
  [PICKUP_TYPE_VALUES.DRIVE_THRU]: {
    enabled: true,
    label: getLabel('PICKUP_INFO', 'driveThru'),
    description: getLabel('PICKUP_INFO', 'driveThruDescription'),
    apiValue: 'drive_thru',
  },
    [PICKUP_TYPE_VALUES.CURBSIDE]: {
    enabled: false,
    label: getLabel('PICKUP_INFO', 'curbside'),
    description: getLabel('PICKUP_INFO', 'curbsideDescription'),
    apiValue: 'curbside',
  },
};
